export function GearSixIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.7269 8.97706L15.7442 2.01835C15.565 1.70886 15.3085 1.45202 15.0003 1.27337C14.6921 1.09472 14.3428 1.00047 13.9873 1H6.01275C5.65718 1.00047 5.30793 1.09472 4.99971 1.27337C4.69148 1.45202 4.43502 1.70886 4.25581 2.01835L0.273105 8.97706C0.0942162 9.28783 0 9.64073 0 10C0 10.3593 0.0942162 10.7122 0.273105 11.0229L4.25581 17.9817C4.43502 18.2911 4.69148 18.548 4.99971 18.7266C5.30793 18.9053 5.65718 18.9995 6.01275 19H13.9873C14.3428 18.9995 14.6921 18.9053 15.0003 18.7266C15.3085 18.548 15.565 18.2911 15.7442 17.9817L19.7269 11.0229C19.9058 10.7122 20 10.3593 20 10C20 9.64073 19.9058 9.28783 19.7269 8.97706ZM10 13.6927C9.27531 13.6927 8.5669 13.4761 7.96434 13.0703C7.36179 12.6646 6.89215 12.0879 6.61483 11.4131C6.3375 10.7384 6.26494 9.9959 6.40632 9.2796C6.5477 8.56329 6.89667 7.90532 7.4091 7.3889C7.92153 6.87247 8.57441 6.52078 9.28517 6.37829C9.99594 6.23581 10.7327 6.30894 11.4022 6.58843C12.0717 6.86792 12.644 7.34121 13.0466 7.94847C13.4492 8.55572 13.6641 9.26966 13.6641 10C13.6644 10.485 13.5698 10.9653 13.3858 11.4135C13.2018 11.8616 12.9319 12.2688 12.5916 12.6118C12.2513 12.9547 11.8472 13.2267 11.4025 13.4122C10.9579 13.5977 10.4813 13.693 10 13.6927Z"
        fill="url(#paint0_linear_3148_2198)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3148_2198"
          x1="20"
          y1="1"
          x2="8.34465e-07"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#27252E" />
          <stop offset="1" stopColor="#5E5A6F" />
        </linearGradient>
      </defs>
    </svg>
  );
}
